import callApi from 'helpers/callApi';

export const getUsers = (params) => callApi({ url: '/users', query: params });
export const getAllUsers = (params) => callApi({ url: '/users', query: { ...params, limit: 10000, page: 1 } });
export const getUserById = (id) => callApi({ url: `/users/${id}` });
export const verify = () => callApi({ url: '/users/me' });
export const getUserClassList = (params) => callApi({ url: '/users/me/classes', query: params });
export const getPointList = (id, params) => callApi({ url: `/users/${id}/points`, query: params });
export const getSpentPointList = (id, params) => callApi({ url: `/users/${id}/spent-points`, query: params });

export const addAdmin = (data) => callApi({ url: '/users/admin', body: data });
export const banUserById = (id) => callApi({ url: `/users/${id}/ban`, method: 'post' });
export const addPoints = (id, data) => callApi({ url: `/users/${id}/points`, body: data });
export const logoff = (data = '') => callApi({ url: '/users/logout', body: data, method: 'post' });
export const verifyUser = (id) => callApi({ url: `/users/${id}/verify`, method: 'post' });
export const rejectUser = (id) => callApi({ url: `/users/${id}/reject`, method: 'post' });

export const updatePermissions = (data) => callApi({ url: '/users/admin', body: data, method: 'put' });
export const editUser = (id, data) => callApi({ url: `/users/${id}`, body: data, method: 'put' });
export const deleteAdmin = (id) => callApi({ url: `/users/admin/${id}`, method: 'delete' });
